import type { MoneyContext } from "../money/MoneyContext";
import type { BetConfig, BetSystem } from "./BetSystemTypes";
import { DefaultBetSystem } from "./BetSystem";

export function createBetSystem(input: {
  config: BetConfig;
  moneyContext: MoneyContext;
}): BetSystem {
  return new DefaultBetSystem({
    config: input.config,
    moneyContext: input.moneyContext,
  });
}